import { render, staticRenderFns } from "./PASIBSA.vue?vue&type=template&id=cd56d5f0&scoped=true&"
import script from "./PASIBSA.vue?vue&type=script&lang=js&"
export * from "./PASIBSA.vue?vue&type=script&lang=js&"
import style0 from "./PASIBSA.vue?vue&type=style&index=0&id=cd56d5f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd56d5f0",
  null
  
)

export default component.exports